import React from 'react'
import { CMSSection } from '../components'
import styles from './style.scss'

/**
 * SessionSaleContent block component
 * Displays customizable WYSIWYG content from the session sale
 *
 * @param {Object} props
 * @param {string} props.content_type - Which content field to display ('reserve_page_content' or 'reserve_page_footer_content')
 * @param {Object} props.session_sale - The session sale object containing the content
 */
export const SessionSaleContent = ({ content_type: contentType, session_sale: sessionSale }) => {
  if (!sessionSale) return null

  const content = sessionSale[contentType]

  if (!content) return null

  return (
    <CMSSection>
      <div
        className={styles.sessionSaleContent}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </CMSSection>
  )
}

SessionSaleContent.propTypes = {
  content_type: React.PropTypes.oneOf(['reserve_page_content', 'reserve_page_footer_content']),
  session_sale: React.PropTypes.shape({
    reserve_page_content: React.PropTypes.string,
    reserve_page_footer_content: React.PropTypes.string
  })
}

SessionSaleContent.defaultProps = {
  content_type: 'reserve_page_content'
}

export default SessionSaleContent
